import styles from "./Article.module.scss";
import dayjs from "dayjs";

export default function Article({ post }) {
  const date = dayjs(post.published_at);
  const modified_date = dayjs(post.updated_at);
  return (
    <article className={styles["Article"]}>
      {post?.feature_image && (
        <figure className={styles["Article__feature-image-wrapper"]}>
          <img
            className={styles["Article__feature-image"]}
            src={post.feature_image}
            alt={post?.feature_image_alt}
          />
        </figure>
      )}
      <header className={styles["Article__header"]}>
        <h1 className={styles["Article__heading"]}>{post.title}</h1>
        {(post?.custom_excerpt || post.excerpt) && (
          <p className={styles["Article__excerpt"]}>
            {post?.custom_excerpt || post.excerpt}
          </p>
        )}
        <div className={styles["Article__meta"]}>
          <div className={styles["Article__meta-author"]}>
            {post?.primary_author?.profile_image && (
              <img
                src={post.primary_author.profile_image}
                height={32}
                width={32}
              />
            )}
            <div>
              {post.primary_author && (
                <div className={styles["Article__meta-author-name"]}>
                  {post.primary_author.name}
                </div>
              )}
              <time
                className={styles["Article__meta-timestamp"]}
                dateTime={`${date.format("YYYY")}-${date.format(
                  "MM"
                )}-${date.format("DD")}`}
                title={`${date.format("DD")} ${date.format(
                  "MMM"
                )} ${date.format("YYYY")}`}
              >
                Published {date.format("DD")} {date.format("MMM")}{" "}
                {date.format("YYYY")}
              </time>
              <br />
              <time
                className={styles["Article__meta-timestamp"]}
                dateTime={`${modified_date.format(
                  "YYYY"
                )}-${modified_date.format("MM")}-${modified_date.format("DD")}`}
                title={`${modified_date.format("DD")} ${modified_date.format(
                  "MMM"
                )} ${modified_date.format("YYYY")}`}
              >
                Updated {modified_date.format("DD")}{" "}
                {modified_date.format("MMM")} {modified_date.format("YYYY")}
              </time>
            </div>
          </div>
        </div>
      </header>
      <section
        className={styles["Article__content"]}
        dangerouslySetInnerHTML={{ __html: post.html }}
      />
    </article>
  );
}
